"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var memo_priorities_1 = require("./memo-priorities");
var strings_1 = require("./strings");
exports.CHAT_ACTIONS = [strings_1.CREATED, strings_1.ENDED];
exports.CHAT_TYPES = [memo_priorities_1.VIDEO];
exports.CHAT_STATUSES = [strings_1.STARTED, strings_1.ENDED];
